var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('a',{staticClass:"new-platform-btn",attrs:{"href":_vm.url,"target":"_blank"}},[_c('span',{staticClass:"ai-badge"},[_vm._v("AI")]),_c('span',{staticClass:"btn-text"},[_vm._v("切换天眼AI")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }